export interface IChallenge {
	title: string
	summary: string
	teamCountPreference: number | string
	description: string
	openChallengeType?: string | OpenChallengeType
	isOpenChallenge?: Boolean
	answers?: {
		[key: string]: any
	}
}

export enum OpenChallengeType {
	private = <any>'Private',
	global = <any>'Global',
	organisation = <any>'Organisation',
}
